/**
 * @prettier
 */

const LANGUAGES = [
    { label: 'UK-English', value: 'en' },
    { label: 'US-English', value: 'en-US' },
    { label: 'Français', value: 'fr' },
    { label: 'Español', value: 'es' },
    { label: 'Italiano', value: 'it' },
    { label: 'Deutsch', value: 'de' },
    { label: '繁體中文（香港)', value: 'zh-HK' },
];

export default LANGUAGES;
